import { render, staticRenderFns } from "./SpFourModule3.vue?vue&type=template&id=4799a68f&scoped=true"
import script from "./SpFourModule3.vue?vue&type=script&lang=js"
export * from "./SpFourModule3.vue?vue&type=script&lang=js"
import style0 from "./SpFourModule3.vue?vue&type=style&index=0&id=4799a68f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4799a68f",
  null
  
)

export default component.exports